import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import { useRouter } from 'vue-router';
const __default__ = {
  name: 'ChannelContent'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const router = useRouter();
    const headerConfig = ref({
      title: '频道内容',
      btnList: [{
        label: '返回',
        func: () => {}
      }]
    });
    const tableConfig = reactive({
      data: [{
        sort: 12
      }],
      showPageBar: false,
      listName: '频道分类',
      headerButtonsList: [{
        label: '添加',
        func: () => {
          router.push('/operating/product-operating/channel/add-channel');
        }
      }, {
        label: '移除',
        func: () => {}
      }, {
        label: '导入频道',
        func: () => {}
      }, {
        label: '按名称排序',
        func: () => {}
      }],
      columnList: [{
        label: '',
        prop: '',
        type: 'selection'
      }, {
        label: '序号',
        prop: '',
        type: 'index'
      }, {
        label: '排序',
        prop: 'sort',
        widgetType: 'doubleInput'
      }, {
        label: '显示编号',
        prop: 'sort'
      }, {
        label: '分类名称',
        prop: 'sort'
      }, {
        label: '内容类型',
        prop: 'sort'
      }, {
        label: '频道名称',
        prop: 'sort'
      }, {
        label: '分类属性',
        prop: 'sort'
      }, {
        label: '语言',
        prop: 'sort'
      }, {
        label: '别名',
        prop: 'sort'
      }, {
        label: '上线状态',
        prop: 'sort'
      }, {
        label: '操作',
        prop: 'sort',
        widgetType: 'buttons',
        buttonsList: [{
          label: '移除',
          func: () => {}
        }]
      }]
    });
    return (_ctx, _cache) => {
      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config"])]);
    };
  }

});